module.exports = __webpack_public_path__ + "img/more-icon.990d2a9d.svg";